import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ signOut, user }) => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleSignOut = () => {
    if (window.confirm('Are you sure you want to sign out?')) {
      signOut();
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="brand-link">
          <span className="logo-icon">🚦</span>
          ZTraffic Case Manager
        </Link>
        <span className="app-version" title="Application version">v0.2.0</span>
      </div>

      <div className="navbar-center">
        <div className="navbar-links">
          <Link 
            to="/" 
            className={isActive('/') ? 'active' : ''}
          >
            Dashboard
          </Link>
          <Link 
            to="/intake" 
            className={isActive('/intake') ? 'active' : ''}
          >
            Intake
          </Link>
          <Link 
            to="/search" 
            className={isActive('/search') ? 'active' : ''}
          >
            Search
          </Link>
          <Link 
            to="/calendar" 
            className={isActive('/calendar') ? 'active' : ''}
          >
            Calendar
          </Link>
          <Link 
            to="/settings" 
            className={isActive('/settings') ? 'active' : ''}
          >
            Settings
          </Link>
        </div>
      </div>

      <div className="navbar-actions">
        <button 
          onClick={handleSignOut}
          className="sign-out-button"
          title="Sign Out"
        >
          Sign Out
        </button>
      </div>
    </nav>
  );
};

export default Navbar;